import { ReactNodeViewRenderer as f } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { IMAGE_MOBILE_FULL_WIDTH_STYLES as u } from "../../constants/default-styles.mjs";
import { ImageNameEnum as g, ImageModeEnum as p } from "./image-enum.mjs";
import { convertStyleObjectToCss as d } from "../../utils/style-helpers.mjs";
import { CustomImage as I } from "./custom-image.mjs";
import { Image as L } from "./image.mjs";
import { getContainerWidthFromElement as b } from "./utils/get-container-width-from-element.mjs";
import { getImageAttrs as A } from "./utils/get-image-attrs.mjs";
import { getImageWithLinkHtml as M } from "./utils/get-image-with-link-html.mjs";
import { mergeAttributes as h } from "../../node_modules/@tiptap/core/dist/index.mjs";
const N = L.configure({ inline: !0 }).extend({
  name: g.Inline,
  inline: !0,
  addNodeView() {
    return f(I);
  },
  parseHTML() {
    return [
      {
        tag: "img",
        getAttrs: (t) => {
          const r = t.closest("a"), s = r == null ? void 0 : r.getAttribute("href"), i = A(t), o = b(t), e = t.closest("span.inline-image-wrapper"), n = (e == null ? void 0 : e.hasAttribute("is-mobile-full-width")) || !1;
          return {
            imageMode: p.Inline,
            ...i,
            href: s,
            containerWidth: o,
            isMobileFullWidth: n
          };
        }
      }
    ];
  },
  renderHTML({
    HTMLAttributes: { href: t, alt: r, title: s, width: i, height: o, containerWidth: e, src: n, isMobileFullWidth: l }
  }) {
    const m = {};
    i && o && (m.aspectRatio = `${i}/${o}`), e !== "auto" && (m.width = e);
    const c = h({
      src: n,
      alt: r,
      title: s,
      width: i,
      style: d(m)
    }), a = M(c, { href: t });
    return l ? [
      "span",
      { class: "inline-image-wrapper is-mobile-full-width" },
      ["head", {}, ["style", { type: "text/css" }, u]],
      a
    ] : a;
  }
});
export {
  N as InlineImage
};
